export default "__VITE_ASSET__CNa_9Y9K__"